import { render } from "./ApplicationsFocus.vue?vue&type=template&id=7d2b9c4a&scoped=true"
import script from "./ApplicationsFocus.vue?vue&type=script&lang=js"
export * from "./ApplicationsFocus.vue?vue&type=script&lang=js"

import "./ApplicationsFocus.vue?vue&type=style&index=0&id=7d2b9c4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2b9c4a"]])

export default __exports__